import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const unitsK = {
  millimeter: "units.millimeter",
  centimeter: "units.centimeter",
};

export const useUnitsT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      millimeter: t(unitsK.millimeter),
      centimeter: t(unitsK.centimeter),
    }),
    [i18n.language]
  );
};